// extracted by mini-css-extract-plugin
export default {"priceWrapper":"ItemCost_priceWrapper__UmUx-","itemPriceBold":"ItemCost_itemPriceBold__PQ6kc","sum":"ItemCost_sum__iKi9j","itemCurrencyBold":"ItemCost_itemCurrencyBold__I0Ja+"};